import { getRequest, patchRequest } from "../utils/axios";

const projectQuery = (projectHash) => `?project=${projectHash}`;

export const sitePagesService = {
  list: (projectHash, onSuccess, onError) =>
    getRequest(`/api/v1/site-pages/${projectQuery(projectHash)}`, onSuccess, onError),
  update: (hash, projectHash, data, onSuccess, onError) =>
    patchRequest(
      `/api/v1/site-pages/${hash}/${projectQuery(projectHash)}`,
      data,
      onSuccess,
      onError,
    ),
  sitemap: (projectHash, onSuccess, onError) =>
    getRequest(`/api/v1/site-pages/sitemap/${projectQuery(projectHash)}`, onSuccess, onError),
};
